import {pureApiFetch} from "./pure-fetch";
import BASE_URL from "../const";

export const calcApiFetch = (urlPart, params, okCallback, errCallback) => {
    const url = BASE_URL + urlPart;
    const requestParams = Object.assign({
            mode: "cors",
            headers: {}
        }, params
    );

    pureApiFetch(url, requestParams, okCallback, errCallback);
};


export const citiesFetch = (okCallback, errCallback) => {
    const url = BASE_URL + '/cdek/cities.php';
    const requestParams = Object.assign({
            mode: "cors",
            headers: {}
        }
    );
    pureApiFetch(url, requestParams, okCallback, errCallback);
};

export const pvzFetch = (id, okCallback, errCallback) => {
    const url = BASE_URL + '/cdek/pvz.php?id=' + id;
    const requestParams = Object.assign({
            mode: "cors",
            headers: {}
        }
    );
    pureApiFetch(url, requestParams, okCallback, errCallback);
};
